import { render, staticRenderFns } from "./site-notification-order.vue?vue&type=template&id=6b3a3119&"
import script from "./site-notification-order.vue?vue&type=script&lang=js&"
export * from "./site-notification-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports